// ui框架样式配置
export const themeVars = {
  popupRoundBorderRadius: '6px',
  emptyPadding: '0px',
  emptyDescriptionPadding: '0px',
};

export const searchthemeVars = {
  emptyDescriptionColor: "var(--van-white)"
};